import React from 'react';
import Slider from 'react-slick';
import SecurityBannerImg from '../../../assets/images/security-banner.jpg';


const SecurityBanner = () => {
    const bannerSettings = {
        dots: true,
        infinite: true,
        speed: 200,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        fade: true,
        arrows: false,
        slidesToScroll: 1
    };

    return (
        <section className="banner-one">
            <div className="container-fluid p-0">
                <Slider className="banner-one-slider" {...bannerSettings}>
                    <div className="banner-one-slider-item">
                        <div className="banner-one-slider-item-image zoom-in">
                            <img
                                src={SecurityBannerImg}
                                alt="Security Banner"
                                className="img-fluid w-100"
                                style={{ maxHeight: '500px', objectFit: 'cover' }}
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-7 col-lg-8 col-md-10">
                                    <div className="banner-one-info" id='banner-one-info'>
                                        <div className="banner-title fade-left hero">
                                            <h1>Security</h1>
                                        </div>
                                        <div className="section-details fade-left head">
                                            <h3 className='text-white'>
                                                Trusted security services, wherever you are
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Slider>
            </div>
        </section>
    );
};

export default SecurityBanner;
